/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumnscans2Inputs */

const en_opportunitiescolumnscans2 = /** @type {(inputs: Opportunitiescolumnscans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scans`)
};

const de_opportunitiescolumnscans2 = /** @type {(inputs: Opportunitiescolumnscans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scans`)
};

/**
* | output |
* | --- |
* | "Scans" |
*
* @param {Opportunitiescolumnscans2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumnscans2 = /** @type {((inputs?: Opportunitiescolumnscans2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumnscans2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumnscans2(inputs)
	return de_opportunitiescolumnscans2(inputs)
});
export { opportunitiescolumnscans2 as "opportunitiesColumnScans" }